import { Form, Input, InputNumber } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { FieldValue } from 'app/components/commons/Hotel/Contacts/FieldView/FieldView';
import { Option, Select } from 'app/components/fields/Select';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useCountries } from 'app/hooks/data/useCountries';

import styles from '../General.module.scss';

import { SelectValue } from './SelectValue';

const RULES = [{ required: true }];

export const Address = () => {
  const { isEditMode } = useContext(ViewEditModeContext);

  const { data: countries } = useCountries();

  return (
    <>
      <FormLineLayout label="Street" isRequired>
        <Form.Item
          name={['address', 'street']}
          rules={isEditMode ? RULES : undefined}
        >
          {isEditMode ? (
            <Input placeholder="Street name and number" />
          ) : (
            <FieldValue />
          )}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="Zip" isRequired>
        <Form.Item
          name={['address', 'zipCode']}
          rules={isEditMode ? RULES : undefined}
        >
          {isEditMode ? <Input placeholder="Postal code" /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="City" isRequired>
        <Form.Item
          name={['address', 'city']}
          rules={isEditMode ? RULES : undefined}
        >
          {isEditMode ? <Input /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout
        label="Country"
        isRequired
        rightClassName={styles.selectField}
      >
        <Form.Item
          name={['address', 'countryId']}
          rules={isEditMode ? RULES : undefined}
        >
          {isEditMode ? (
            <Select placeholder="France, UK, ...">
              {countries?.map((country) => (
                <Option value={country.id} key={country.id}>
                  {country.name}
                </Option>
              ))}
            </Select>
          ) : (
            <SelectValue options={countries || []} />
          )}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="Station">
        <Form.Item
          name="subway"
          // This rule never causes an error (it accepts any Input value). It only exists
          // because without a rule the Input's value can't be edited (antd < 4.17.0 bug).
          rules={[{ type: 'string', message: 'Please enter a text' }]}
        >
          {isEditMode ? <Input placeholder="Metro station" /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout
        label="Latitude"
        isRequired
        rightClassName={styles.numberField}
      >
        <Form.Item
          name={['location', 'coords', 'lat']}
          rules={isEditMode ? RULES : undefined}
        >
          {isEditMode ? <InputNumber /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout
        label="Longitude"
        isRequired
        rightClassName={styles.numberField}
      >
        <Form.Item
          name={['location', 'coords', 'lng']}
          rules={isEditMode ? RULES : undefined}
        >
          {isEditMode ? <InputNumber /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
    </>
  );
};
